import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getEventVehiclesByEventId = (eventId, searchString) => {
    return vdkEmHappinessPortalApi.post(`events/vehicles/all`, { eventId: eventId, searchString: searchString });
};
const getPaginatedEventVehiclesByEventId = (eventId, query) => {
    return vdkEmHappinessPortalApi.post(`/events/${eventId}/get-vehicles`, query);
};
const getEventVehicleById = (id) => {
    return vdkEmHappinessPortalApi.get(`/event-vehicles/${id}`);
};
const createEventVehicle = (request) => {
    return vdkEmHappinessPortalApi.post(`/events/${request.eventId}/vehicles`, request);
};
const updateEventVehicle = (request) => {
    return vdkEmHappinessPortalApi.put(`/event-vehicles/${request.id}`, request);
};
const checkEventVehicleDuplicates = (request) => {
    return vdkEmHappinessPortalApi.post('/event-vehicles/check-duplicates', request);
};
const deleteEventVehicle = (id) => {
    return vdkEmHappinessPortalApi.delete(`/event-vehicles/${id}`);
};
const getAttendeesByRouteVehicleId = (routeVehicleId) => {
    return vdkEmHappinessPortalApi.post('/family-fest/attendee-assignments/get-all-by-vehicle', { routeVehicleId, pageNumber: 1, pageSize: 500 });
};
const assignAttendeeToRouteVehicle = (assignmentIds, routeVehicleId) => {
    return vdkEmHappinessPortalApi.patch('/family-fest/attendee-assignments/assign-to-route-vehicle', { assignmentIds, routeVehicleId });
};
const sendVehicleInformationToSupplier = (vehicleId) => {
    return vdkEmHappinessPortalApi.post(`/event-vehicles/${vehicleId}/send-information`);
};
const exportBirthdayInfoToExcel = (vehicleId) => {
    return vdkEmHappinessPortalApi.post(`/event-vehicles/${vehicleId}/send-birthday-info`, {}, { responseType: 'blob' });
};
const eventVehicleAPI = {
    getEventVehiclesByEventId,
    getPaginatedEventVehiclesByEventId,
    getEventVehicleById,
    createEventVehicle,
    updateEventVehicle,
    checkEventVehicleDuplicates,
    deleteEventVehicle,
    getAttendeesByRouteVehicleId,
    assignAttendeeToRouteVehicle,
    sendVehicleInformationToSupplier,
    exportBirthdayInfoToExcel
};
export default eventVehicleAPI;
